<template>
  <div class="access-instructions-config-generation">
    <el-card>
      <template #header>
        <div class="card-header">
          <el-icon><Delete /></el-icon> <!-- 假设这里有 Delete 图标，如果没有可替换为合适的图标 -->
          <span>文件删除</span>
        </div>
      </template>
      <div class="card-content">
        <p><strong>url</strong> : /fos/file/delete</p>
        <p><strong>请求方式</strong> : POST</p>
        <p><strong>接口说明</strong> : 文件删除。</p>

        <p><strong>请求参数</strong> :</p>
        <el-table :data="requestParams" border>
          <el-table-column prop="name" label="参数名称"></el-table-column>
          <el-table-column prop="type" label="参数类型"></el-table-column>
          <el-table-column prop="required" label="是否必填"></el-table-column>
          <el-table-column prop="description" label="说明"></el-table-column>
        </el-table>
        <p><strong>接口返回</strong> :</p>
        <el-table :data="responseData" border>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="type" label="类型"></el-table-column>
          <el-table-column prop="description" label="说明"></el-table-column>
        </el-table>
        <p><strong>备注</strong> : 返回的数据格式为JSON</p>

        <p><strong>参数实例</strong> :</p>
        <pre><code class="plaintext">
accessKey=xxx&amp;objectKey=/xxx/yyy/zzz&amp;fosFileId=fid
        </code></pre>

        <p><strong>接口返回实例</strong> :</p>
        <p><strong>正确返回</strong></p>
        <pre><code class="json" ref="correctResponseCode">
{
"status": 100,
"unixTime": "2024-04-01T05:14:46.672+00:00",
"error": null,
"data": "数据删除成功"
}
        </code></pre>
        <p><strong>错误返回</strong></p>
        <pre><code class="json" ref="errorResponseCode">
{
  "status": 0,
  "unixTime": 1541508995344,
  "error": "数据删除失败",
  "data": null
}
        </code></pre>
      </div>
      <div class="access-instructions-footer">
        <!-- 修改链接地址和文本为文件路径查询 -->
        <router-link to="/access-instructions/file-path-query" class="next-document-link">
          <el-icon><ArrowLeft /></el-icon> 文件路径查询
        </router-link>
        <!-- 修改链接地址和文本为附录 -->
        <router-link to="/access-instructions/appendix" class="next-document-link">
          附录 <el-icon><ArrowRight /></el-icon>
        </router-link>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Delete, ArrowRight, ArrowLeft } from '@element-plus/icons-vue';
import '@/styles/common-access-instructions.css';
import hljs from 'highlight.js';
import 'highlight.js/styles/default.css';

// 定义请求参数数据
const requestParams = [
  { name: 'accessKey', type: 'String', required: '是', description: '通行密钥，通过/fos/client/access_key获取' },
  { name: 'objectKey', type: 'String', required: '是', description: 'object密钥，FOS平台上自行设置的字符串' },
  { name: 'fosFileId', type: 'String', required: '是', description: 'FOS文件ID' }
];

// 定义接口返回数据
const responseData = [
  { name: 'status', type: 'int', description: '状态码(100-成功 0-失败)' },
  { name: 'error', type: 'Object', description: '错误信息(成功时为null)' },
  { name: 'data', type: 'Object', description: '返回数据(失败时为null)' }
];

const correctResponseCode = ref(null);
const errorResponseCode = ref(null);

onMounted(() => {
  if (correctResponseCode.value) {
    hljs.highlightElement(correctResponseCode.value);
  }
  if (errorResponseCode.value) {
    hljs.highlightElement(errorResponseCode.value);
  }
});
</script>

<style scoped>
.access-instructions-config-generation {
  padding: 20px;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 500;
}

.card-content {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.card-content p {
  margin-bottom: 10px;
}

.card-content pre {
  background-color: #f4f4f4;
  padding: 10px;
  border-radius: 4px;
  overflow-x: auto;
}

.card-content code {
  font-family: 'Courier New', Courier, monospace;
}

.access-instructions-footer {
  display: flex;
  justify-content: space-between;
}

.next-document-link {
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>